/* eslint-disable react/prop-types */
import React from 'react'

import OhIcon from 'assets/images/oh_logo_transparent.svg'

import DeclinedSubscriptionFlag from './DeclinedSubscriptionFlag'
import FlagsComponent from './FlagsComponent'
import * as styles from './styles'

import { TitleDescription } from '../../../components/TitleDescription'

export const MembershipBlock = (props) => {
  const { selectedParentDetails } = props

  const crmFlags = selectedParentDetails?.crm_flags

  const cardWidth = crmFlags?.length > 1 ? 548 : 264
  return (
    <styles.Wrapper width={cardWidth}>
      <styles.Body>
        <styles.InfoBlock>
          <TitleDescription
            heading="name"
            description={`${selectedParentDetails?.first_name} ${selectedParentDetails?.last_name}`}
          />
          {selectedParentDetails?.centre?.name ? (
            <TitleDescription
              heading="centre"
              description={
                <styles.Heading>
                  <styles.Icon src={OhIcon} alt="oh-icon" />
                  {`${selectedParentDetails?.centre?.name?.toLowerCase()}`}
                </styles.Heading>
              }
            />
          ) : null}
        </styles.InfoBlock>

        <styles.InfoBlock>
          <TitleDescription
            heading="FLAGS"
            description={<FlagsComponent flags={crmFlags} />}
          />
        </styles.InfoBlock>

        {/* Renders only when the parent carries an active "Declined
            subscription" mark — the one place it can be seen and undone
            without knowing which day they last visited.

            On its OWN row, not as a second child of the FLAGS InfoBlock:
            that block is `display: flex; justify-content: space-between`, so
            the chip sat beside the heading and its label ran straight off the
            card's right edge. Full width here, and it wraps instead. */}
        <styles.DeclinedFlagRow>
          <DeclinedSubscriptionFlag parentUuid={selectedParentDetails?.uuid} />
        </styles.DeclinedFlagRow>

        <styles.InfoBlock>
          {/* <TitleDescription
            heading="current membership status"
            description={selectedParentDetails?.member_status}
          /> */}
          {/* <TitleDescription
            heading="membership purchase"
            description={purchased_at ? dayjs(purchased_at).format('D MMM, YY') : 'NA'}
          /> */}
          {/* <TitleDescription
            heading="membership start"
            description={
              start_date ? dayjs(start_date).format('D MMM, YY') : 'NA'
            }
          /> */}
        </styles.InfoBlock>
      </styles.Body>
    </styles.Wrapper>
  )
}
